import moment from "moment-timezone";
import { formatCalendarDateLabel, formatCalendarTimeLabel } from "../../../calendar/calendarUx";

const salonWallClock = (startDatetime, timezone) => {
  if (!startDatetime || !timezone || !moment.tz.zone(timezone)) return startDatetime;
  const parsed = moment.utc(startDatetime);
  return parsed.isValid() ? parsed.tz(timezone).format("YYYY-MM-DD HH:mm:ss") : startDatetime;
};

export const clientAppointmentDateLabel = (startDatetime, timezone) => formatCalendarDateLabel(salonWallClock(startDatetime, timezone));
export const clientAppointmentTimeLabel = (startDatetime, timezone) => formatCalendarTimeLabel(salonWallClock(startDatetime, timezone));
